package com.exura.features.legacyplans.data.mappers

import com.exura.features.firebase.data.mappers.SerializableMappers
import com.exura.features.legacyplans.data.remote.dto.DetailedPlanDto
import com.exura.features.legacyplans.domain.model.*
import dev.gitlive.firebase.firestore.CollectionReference

class DetailedPlanMappers : SerializableMappers<DetailedPlan, DetailedPlanDto> {

    override fun toDto(model: DetailedPlan): DetailedPlanDto = DetailedPlanDto(
        id = model.id,
        title = model.title,
        shortDescription = model.shortDescription,
        tasks = model.tasks,
        checkups = model.checkups,
        restrictions = model.restrictions,
        status = model.status
    )

    override fun toDomain(dto: DetailedPlanDto, collection: CollectionReference?, id: String?): DetailedPlan = DetailedPlan(
        firebaseDocId = id,
        firebaseDocPrefix = collection,
        id = dto.id,
        title = dto.title,
        shortDescription = dto.shortDescription,
        tasks = dto.tasks,
        checkups = dto.checkups,
        restrictions = dto.restrictions,
        status = dto.status
    )
}
